import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Divider } from "semantic-ui-react";
import * as FiIcons from "react-icons/fi";

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px;
`;

const CardContainer = styled.div`
    max-width: 800px;
    border-width: 1px;
    border-radius: 5px;
    border-style: ${(props) => (props.border ? "solid" : "none")};
    ${(props) =>
        props.borderColor ? `border-color: ${props.borderColor};` : ""};
    margin: 5px 0px;
    text-align: left;
    background: ${(props) => (props.completed ? "rgb(212, 247, 215)" : props.background ? props.background : "unset")};
    max-height: ${(props) => (props.expanded ? "300px" : "50px")};
    height: auto;
`;

const CardHeader = styled.div`
    font-size: 15px;
    font-weight: bold;
    text-decoration: ${(props) => (props.completed ? "line-through" : "none")};
`;

const CardContent = styled.div`
    visibility: ${(props) => (props.expanded ? "visible" : "hidden")};
    opacity: ${(props) => (props.expanded ? "1" : "0")};
    transition: visibility 0s, opacity 0.5s linear;
    padding: 15px;
    padding-top: 0px;
`;

const ToggleIcon = styled.div`
    align-self: center;
`;

const CollapsibleCard = ({
    children,
    title,
    background,
    border,
    borderColor,
    headerActions,
    forceExpanded,
    completed,
    collapseSignal,
}) => {
    const [expanded, setExpanded] = useState(forceExpanded ?? false);

    useEffect(() => {
        if (forceExpanded !== undefined) {
            setExpanded(forceExpanded);
        }
    }, [forceExpanded]);

    useEffect(() => {
        if (collapseSignal) {
            setExpanded(false);
        }
    }, [collapseSignal]);

    return (
        <CardContainer
            expanded={expanded}
            background={background}
            border={border}
            borderColor={borderColor}
            completed={completed}
        >
            <Row expanded={expanded} onClick={() => setExpanded(!expanded)}>
                <CardHeader completed={completed}>{title}</CardHeader>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
                    {typeof headerActions === "function" ? headerActions({ expanded }) : headerActions}
                    <ToggleIcon>
                        {expanded ? (
                            <FiIcons.FiChevronUp />
                        ) : (
                            <FiIcons.FiChevronDown />
                        )}
                    </ToggleIcon>
                </div>
            </Row>

            <CardContent expanded={expanded}>
                <Divider style={{ marginTop: "0px" }} />
                {children}
            </CardContent>
        </CardContainer>
    );
};

export default CollapsibleCard;
